<template>
    <div>
    <div class="py-3"></div>
    
 
    <div class="py-3"></div>
    <div class="py-3"></div>



    <v-card
        class="mx-auto"
        max-width="90%"
    >
    <v-card-title class="white--text orange darken-4">
      User Directory

      <v-spacer></v-spacer>

      <v-btn
        color="white"
        class="text--primary"
        fab
        small
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-card-title>
    <v-virtual-scroll
      :items="items"
      :item-height="50"
      height="300"
    >
      <template v-slot:default="{ item }">
        <v-list-item>
          <v-list-item-avatar>
            <v-avatar
              :color="item.color"
              size="56"
              class="white--text"
            >
              {{ item.initials }}
            </v-avatar>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ item.fullName }}</v-list-item-title>
          </v-list-item-content>

          <v-list-item-action>
            <v-btn
              depressed
              small
            >
              View User

              <v-icon
                color="orange darken-4"
                right
              >
                mdi-open-in-new
              </v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </template>
    </v-virtual-scroll>
    </v-card>
    </div>   
    
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment'
import store from '../../store';
import config from '../../config/config';
import { format, parseISO } from 'date-fns'
 const { s3_upload } = require("../../util/fileutil");

export default {
    name: 'UserList',

    data: () => ({
        downloadUrl:"http://madbundle.studiomadpj.co.kr/",
        loadingData:false,        
        inputTemplate:[],
        templateVer:"1.0.0",
        date_begin: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
        date_end:format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
        date_picker_1: false,
        date_picker_2: false,
        comment:"",
        itemInfoList:[
            {
                name:'보석',
                value:'item_type_1',
            },
            {
                name:'골드',
                value:'item_type_2',
            }   
        ],
        selected_itemList:[],   ///인덱스만 담기것지 나중에 전송할때는 한번 가공하도록 한다         
        selected_itemList_count:[],   
        title_type_items:[],    //타이틀 설정 하도록 
        // 데이터테이블에 저장위치의 경로와 다운로드 버튼을 만들어 클릭하면 나올 수 있게 한다.
        headers: [            
            { text: '버전', value: 'title' },
            { text: '관리자', value: 'admin' },
            { text: '등록일자', value: 'regist_date' },
            { text: '코멘트', value: 'comment' },
            { text: '경로', value: 'regist_date' },
            { text: '다운로드', value: 'comment' },
        ],
        history_all:[
            {  
                title: '테스트 메일 입니다.',
                admin: 'justin',
                regist_date:'2021-10-10 12:00:00',
                get_date:'2021-10-10 12:00:00',
                target:'ALL',
                active_yn:'Y',
            },
        ]
    }),

    created()
    {
        this.date_end = moment().add(3,'M').format('yyyy-MM-DD');
        this.Refresh_TempatleLogs();
    },

    methods:{
        ...mapActions([
            'GET_TEMPLATE_LOG',
            'INSERT_TEMPLATE_LOG'
        ]),
        IsActiveState(_item)
        {
            return _item.active_yn=="Y"?true:false;
        },
        OnUpload_Template()
        {
        //    function s3_upload_tempalte(_inputFile, _fileName , _listener)
            console.log("OnUpload_Template " + JSON.stringify(this.inputTemplate));
            //function s3_upload_tempalte(this.inputTemplate, _fileName , _listener)
            let packageName = this.$store.state.selected_game_package;
            let templateVer = this.templateVer;
            let comment = this.comment;
            let serverState= "dev";
            if(this.isLive)
                serverState = "live";
            else
                serverState = "dev";
                
            let fileName = this.CreateRandomFileName();
            let file_path = `CommonTemplate/${serverState}/${packageName.replaceAll('.', '_')}/${fileName}`;
            console.log(file_path);
            ///file_path = "CommonTemplate/test";

            // FileUpload_Temp(this.inputTemplate, file_path, ()=>{
            //     console.log("어쨌든간 완료다");
            // }); 
            // this.INSERT_TEMPLATE_LOG({packageName, templateVer , comment, file_path}).then((body_data)=>{
            //     this.Refresh_TempatleLogs();
            // });
        },
        Refresh_TempatleLogs()
        {//등록된 아이템 정보 + 1
            let packageName = this.$store.state.selected_game_package;
            
            this.GET_TEMPLATE_LOG({packageName}).then((body_data)=>{
                console.log(body_data);
                this.history_all = body_data.log_list;
                console.log(this.history_all);
            })
            .catch((err) => {
                this.error = err;
                console.log(err);
            })
        },
        CreateRandomFileName()
        {
            let baseStrContainer = '123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
            let charactersLength = baseStrContainer.length;
            let randomString = '';
            for (var i = 0; i < 16; i++) {
                //return Math.random() * (max - min) + min;
                randomString += baseStrContainer.charAt(this.getRandomArbitrary(0, charactersLength - 1));
            }
            return randomString;
        },

        getRandomArbitrary(min, max) {
            return Math.random() * (max - min) + min;
        },

        OnRemoveItem(_index)
        {
            this.selected_itemList[_index] = undefined;
            this.Refresh_ItemInfo();
        },
        onFileChange(file) {
            console.log("onFileChang2e  1  : " + JSON.stringify(file));
            var files = this.inputTemplate;// || e.dataTransfer.file;
            console.log("onFileChange  2  + " + JSON.stringify(this.inputTemplate) );
        
            //this.inputTemplate = files[0];
            console.log("onFileChange  3");
            console.log(this.inputTemplate);
            console.log("onFileChange  4");
            //this.createImage(files[0]);
        },
    },
    computed: {
        isLive(){
            return config.isLive;
        },
        computedDateFormattedMomentjs_begin () {
            return this.date_begin ? moment(this.date_begin).format('YYYY-MM-DD') : ''
        },
        computedDateFormattedMomentjs_end () {
            return this.date_end ? moment(this.date_end).format('YYYY-MM-DD') : ''
        },  
        items () {
        const namesLength = this.names.length
        const surnamesLength = this.surnames.length
        const colorsLength = this.colors.length

        return Array.from({ length: 10000 }, (k, v) => {
          const name = this.names[this.genRandomIndex(namesLength)]
          const surname = this.surnames[this.genRandomIndex(surnamesLength)]

          return {
            color: this.colors[this.genRandomIndex(colorsLength)],
            fullName: `${name} ${surname}`,
            initials: `${name[0]} ${surname[0]}`,
          }
        })
      }
    },
    components:{
    },
    watch :{
            '$store.state.selected_game_package': function() {
            console.log("WHAT IS THIS? " + this.$store.state.selected_game_package)
            this.Refresh_TempatleLogs();
        }
    }
};
</script>
